// LRU cache backed by an insertion-ordered Map; onEvict(key, value) fires when a key is dropped.
export class LruCache {
  constructor (capacity, onEvict) {
    if (!(capacity > 0)) throw new Error('LruCache capacity must be > 0')
    this.capacity = capacity
    this.onEvict = onEvict
    this._map = new Map()
  }

  has (key) {
    return this._map.has(key)
  }

  get (key) {
    if (!this._map.has(key)) return undefined
    const value = this._map.get(key)
    this._map.delete(key)
    this._map.set(key, value) // re-insert as most-recently-used
    return value
  }

  delete (key) {
    return this._map.delete(key)
  }

  set (key, value) {
    if (this._map.has(key)) this._map.delete(key)
    this._map.set(key, value)
    while (this._map.size > this.capacity) {
      const oldestKey = this._map.keys().next().value
      const oldestValue = this._map.get(oldestKey)
      this._map.delete(oldestKey)
      if (this.onEvict) this.onEvict(oldestKey, oldestValue)
    }
    return value
  }

  clear () {
    this._map.clear()
  }

  get size () {
    return this._map.size
  }
}
